// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:29
import { RTMSResource_abstract } from './../abstract/SagaSchema/RTMSResource_abstract';
export class RTMSResource extends RTMSResource_abstract {}
